import { render } from "./VF-label.vue?vue&type=template&id=abdf4df4"
import script from "./VF-label.vue?vue&type=script&lang=js"
export * from "./VF-label.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__